// AI-CONTEXT: See docs/features/public-livereport-data.md
// AI-CONTEXT: See docs/patterns.md#cf-public-onrequest-read

// Same-origin rewrite in production (firebase.json `/api/livereport-data`);
// the dev server has no rewrite, so it calls the function directly.
export const PUBLIC_REPORT_DATA_ENDPOINT = process.env.NODE_ENV === 'production'
    ? '/api/livereport-data'
    : 'https://europe-west1-deccos-app.cloudfunctions.net/getPublicLiveReportData'

/**
 * @typedef {object} PublicReportDataRequest
 * @property {string} reportId - LiveReports2 `ID` of the shared report
 * @property {string} [code] - Share code the viewer entered (empty for an open report)
 * @property {'hierarchy'|'chainType'} kind - What to fetch
 * @property {string} id - QuestionnaireFields `ID`; must sit as a QUESTION widget in the report
 */

/**
 * Asks getPublicLiveReportData for the answers behind a widget of a shared
 * report. Any non-200 answer is thrown — with `status` and the server's error
 * `code` — so a refusal shows up as an error in the widget, never as an empty
 * chart.
 *
 * @param {PublicReportDataRequest & Object<string, *>} request - Plus the hierarchy params for kind 'hierarchy'
 * @returns {Promise<object>} The JSON body
 */
const callPublicReportData = async (request) => {
    const res = await fetch(PUBLIC_REPORT_DATA_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(request),
    })

    if (res.ok) return res.json()

    let code = 'unknown'
    try {
        code = (await res.json()).error || code
    } catch (e) {
        // A 500 from the hosting layer has no JSON body; the status says enough.
    }
    const error = new Error(`getPublicLiveReportData ${res.status}: ${code}`)
    error.status = res.status
    error.code = code
    throw error
}

export default callPublicReportData
